import { useState } from "react";
import { Link } from "react-router-dom";

// Hardcoded mock data strictly matching the elements and visuals seen in the provided image
const featuredProductsData = [
  {
    id: 1,
    name: "Aliquam Consequat",
    category: "Fruits",
    price: "₹26.00",
    oldPrice: "₹143.00",
    img: `${process.env.PUBLIC_URL}/img/product/product1.jpg`,
  },
  {
    id: 2,
    name: "Quisque In Ante",
    category: "Fruits",
    price: "₹20.00",
    oldPrice: "₹116.00",
    img: `${process.env.PUBLIC_URL}/img/product/product2.jpg`,
  },
  {
    id: 3,
    name: "Mauris Vel Tellus",
    category: "Fruits",
    price: "₹45.00",
    oldPrice: "₹143.00",
    img: `${process.env.PUBLIC_URL}/img/product/product3.jpg`,
  },
  {
    id: 4,
    name: "Donec Non Est",
    category: "Fruits",
    price: "₹46.00",
    oldPrice: "₹101.00",
    img: `${process.env.PUBLIC_URL}/img/product/product4.jpg`,
  },
  {
    id: 5,
    name: "Cras Neque Metus",
    category: "Fruits",
    price: "₹72.00",
    oldPrice: "₹161.00",
    img: `${process.env.PUBLIC_URL}/img/product/product5.jpg`,
  },
  {
    id: 6,
    name: "Donec Non Est",
    category: "Fruits",
    price: "₹46.00",
    oldPrice: "₹101.00",
    img: `${process.env.PUBLIC_URL}/img/product/product6.jpg`,
  },
  {
    id: 7,
    name: "Mauris Vel Tellus",
    category: "Fruits",
    price: "₹56.00",
    oldPrice: "₹143.00",
    img: `${process.env.PUBLIC_URL}/img/product/product7.jpg`,
  },
  {
    id: 8,
    name: "Proin Lectus Ipsum",
    category: "Fruits",
    price: "₹36.00",
    oldPrice: "₹132.00",
    img: `${process.env.PUBLIC_URL}/img/product/product8.jpg`,
  },
  {
    id: 9,
    name: "Donec Non Est",
    category: "Fruits",
    price: "₹46.00",
    oldPrice: "₹101.00",
    img: `${process.env.PUBLIC_URL}/img/product/product9.jpg`,
  },
];

export default function FeaturedProducts() {
  // Maintaining your state and pagination architecture rules unchanged
  const [page, setPage] = useState(0);
  const itemsPerPage = 9; // Displaying all 9 items concurrently to yield the 3x3 layout format

  const pages = [];
  for (let i = 0; i < featuredProductsData.length; i += itemsPerPage) {
    pages.push(featuredProductsData.slice(i, i + itemsPerPage));
  }

  return (
    <div className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-10">
          <p className="text-sm italic text-[#43a047] font-serif tracking-wide mb-1">
            Recently added our store
          </p>
          <h2 className="text-2xl md:text-3xl font-medium text-[#112244] tracking-wide">
            Featured Products
          </h2>
        </div>

        <div className="relative">
          {/* Slider Pagination Controls */}
          {pages.length > 1 && (
            <div className="flex justify-center gap-2 mb-8">
              {pages.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setPage(i)}
                  className={`w-2.5 h-2.5 rounded-full transition-colors ${
                    i === page
                      ? "bg-[#43a047]"
                      : "bg-gray-300 hover:bg-gray-400"
                  }`}
                />
              ))}
            </div>
          )}

          {/* 3 Columns x 3 Rows Clean Row Grid Layout */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-10 gap-x-8">
            {pages[page] &&
              pages[page].map((product) => (
                <div
                  key={product.id}
                  className="flex items-center gap-4 bg-white p-2 transition-all duration-200 group"
                >
                  {/* Product Thumbnail Layout (Left side image block) */}
                  <div className="w-24 h-24 flex-shrink-0 bg-[#fbfbfb] border border-gray-50 rounded-sm overflow-hidden flex items-center justify-center p-2">
                    <Link to={"products"}>
                      <img
                        src={product.img}
                        alt={product.name}
                        className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-300"
                      />
                    </Link>
                  </div>

                  {/* Content Body Layout (Right side content data text parameters) */}
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-normal text-gray-500 hover:text-[#43a047] transition-colors truncate mb-1">
                      <Link to={`/products`}>{product.name}</Link>
                    </h4>

                    <p className="text-xs text-gray-400 font-light mb-2">
                      {product.category}
                    </p>

                    <div className="flex items-center gap-2 text-sm font-bold">
                      {/* <span className="text-[#8bc34a]">{product.price}</span>
                      <span className="text-gray-300 line-through font-normal text-xs">
                        {product.oldPrice}
                      </span> */}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
